/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取今天上演场次提示
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.ShowRemindRes;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/order/ticket-folder/show-remind`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
